import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from "react";
import { useIsMounted } from "../../utils/useIsMounted";
import { Loading } from "../Loading";
export const ClientSuspense = ({ children }) => {
    const isMounted = useIsMounted();
    return isMounted ? (_jsx(Suspense, { fallback: _jsx(Loading, {}), children: children })) : (_jsx(Loading, {}));
};
